export const selectReducer = (state) => state.w2pContentManagement;

export const selectW2PContent = (state) =>
  selectReducer(state) ? selectReducer(state).get('w2pContent') : undefined;
